import React, { useContext, useState } from 'react'
import { Link } from 'react-router-dom'
import useTemplateHook from '../template/templateHook'
import { useTranslation } from 'react-i18next'
import nextArrow from '../../assets/small-next-white-icon.svg'
import Profile from '../../assets/profile'
import Watchlist from '../../assets/myWatchlist'
import Favorite from '../../assets/favorite'
import Subscription from '../../assets/subscription'
import Transaction from '../../assets/transaction'
import ChangePlan from '../../assets/changePlan'
import HandBag from '../../assets/handBag'
import SignOut from '../../assets/signOut'
import Cart from '../../assets/cart'
import OrderHistory from '../../assets/orderHistory'
import Wishlist from '../../assets/wishlist'
import Address from '../../assets/address'
import { AppContext } from '../../context/app'

const MobileNavDropDown = ({
  titleColor,
  borderTop,
  backgroundColor = 'transparent',
  isLeftAligned = false,
  useWhiteBorder = false,
}) => {
  const { t } = useTranslation()
  const [selectedMenu, setSelectedMenu] = useState('main')
  const { logoutCall, handleSubscription } = useTemplateHook()
  const { modulePermissions } = useContext(AppContext)

  const finalBorderTop = useWhiteBorder ? '1.5px solid white' : borderTop

  const justifyClass = isLeftAligned ? 'justify-start' : 'justify-center'

  const paddingClass = isLeftAligned ? 'pl-5' : ''

  const paddingClassShop = isLeftAligned ? 'pl-12' : ''

  return (
    <div style={{ backgroundColor: backgroundColor }}>
      {selectedMenu === 'main' && (
        <ul className="" style={{ color: titleColor }}>
          <li className="font-semibold">
            <Link
              to="/profile"
              className={`flex items-center ${justifyClass} ${paddingClass} gap-2`}
            >
              <Profile height="13px" width="13px" />
              <p className="text-sm block px-2 py-1 cursor-pointer user-dropdown-menu my-1">
                {t('my_profile')}
              </p>
            </Link>
          </li>

          <li style={{ borderTop: finalBorderTop }} className="font-semibold">
            <Link
              to="/watchlist"
              className={`flex ${justifyClass} ${paddingClass} items-center gap-2`}
            >
              <Watchlist height="13px" width="13px" />
              <p className="text-sm block px-2 py-1 cursor-pointer user-dropdown-menu my-1">
                {t('my_watchlist')}
              </p>
            </Link>
          </li>

          <li style={{ borderTop: finalBorderTop }} className="font-semibold">
            <Link
              to="/favourites"
              className={`flex ${justifyClass} ${paddingClass} items-center gap-2`}
            >
              <Favorite height="13px" width="13px" />
              <p className="text-sm block px-2 py-1 cursor-pointer user-dropdown-menu my-1">
                {t('my_favorites')}
              </p>
            </Link>
          </li>

          <li
            style={{ borderTop: finalBorderTop }}
            className={`flex ${justifyClass} ${paddingClass} items-center font-semibold`}
          >
            <Link to="/subscriptions" className="flex items-center gap-2">
              <Subscription height="13px" width="13px" />
              <p className="text-sm block px-2 py-1 cursor-pointer user-dropdown-menu my-1">
                {t('my_subscriptions')}
              </p>
            </Link>
          </li>

          <li
            style={{ borderTop: finalBorderTop }}
            className={`flex ${justifyClass} ${paddingClass} items-center font-semibold`}
          >
            <Link to="/transactions" className="flex items-center gap-2">
              <Transaction height="13px" width="13px" />
              <p className="text-sm block px-2 py-1 cursor-pointer user-dropdown-menu my-1">
                {t('Transactions')}
              </p>
            </Link>
          </li>

          <li
            style={{ borderTop: finalBorderTop }}
            className={`flex ${justifyClass} ${paddingClass} items-center font-semibold`}
            onClick={handleSubscription}
          >
            <ChangePlan height="13px" width="13px" />
            <p className="text-sm block px-2 py-1 cursor-pointer user-dropdown-menu my-1">
              {t('change_plan')}
            </p>
          </li>

          {modulePermissions?.ecommerce ? (
            <li
              style={{ borderTop: finalBorderTop }}
              className={`flex ${justifyClass} ${paddingClass} items-center font-semibold cursor-pointer`}
              onClick={() => setSelectedMenu('shop')}
            >
              <HandBag height="13px" width="13px" />
              <p className="text-sm block px-2 py-1 my-1">Shop</p>
              <img src={nextArrow} alt="arrow" className="w-4 h-4 ml-2" />
            </li>
          ) : null}

          <li
            style={{ borderTop: finalBorderTop }}
            className={`flex ${justifyClass} ${paddingClass} items-center font-semibold`}
            onClick={logoutCall}
          >
            <SignOut height="13px" width="13px" />
            <p className="text-sm block px-2 py-1 cursor-pointer user-dropdown-menu my-1">
              {t('sign_out')}
            </p>
          </li>
        </ul>
      )}

      {selectedMenu === 'shop' && (
        <ul className="" style={{ color: titleColor }}>
          <li
            style={{ borderTop: finalBorderTop }}
            className={`flex ${justifyClass}  items-center font-semibold cursor-pointer`}
            onClick={() => setSelectedMenu('main')}
          >
            <span className="px-2">←</span>
            <HandBag height="13px" width="13px" />
            <span className="text-sm block px-2 py-1 my-1">Shop</span>
          </li>

          <li
            style={{ borderTop: finalBorderTop }}
            className={`flex ${justifyClass} ${paddingClassShop} items-center font-semibold`}
          >
            <Link to="/cart-details" className="flex items-center gap-2">
              <Cart height="13px" width="13px" />
              <p className="text-sm block px-2 py-1 my-1">My Cart</p>
            </Link>
          </li>

          <li
            style={{ borderTop: finalBorderTop }}
            className={`flex ${justifyClass} ${paddingClassShop} items-center font-semibold`}
          >
            <Link to="/order-history" className="flex items-center gap-2">
              <OrderHistory height="13px" width="13px" />
              <p className="text-sm block px-2 py-1 my-1">Order History</p>
            </Link>
          </li>

          <li
            style={{ borderTop: finalBorderTop }}
            className={`flex ${justifyClass} ${paddingClassShop} items-center font-semibold`}
          >
            <Link to="/wish-list" className="flex items-center gap-2">
              <Wishlist height="13px" width="13px" />
              <p className="text-sm block px-2 py-1 my-1">Wishlist</p>
            </Link>
          </li>

          <li
            style={{ borderTop: finalBorderTop }}
            className={`flex ${justifyClass} ${paddingClassShop} items-center font-semibold`}
          >
            <Link to="/manage-address" className="flex items-center gap-2">
              <Address height="13px" width="13px" />
              <p className="text-sm block px-2 py-1 my-1">My Addresses</p>
            </Link>
          </li>
        </ul>
      )}
    </div>
  )
}

export default MobileNavDropDown
